export default __webpack_public_path__ + "static/rvezy-51eddfbe9f23fe95978cc476c0f878ca.svg";